import {
  disposeMedia as baseDisposeMedia,
  el as baseEl,
  getSettings as getBaseSettings,
  revokeResult as baseRevokeResult,
  state,
} from "./state.js"
import { loopDelayRawToMs } from "./loop-delay-scale.js"

const byId = (id) => document.getElementById(id)
const clamp = (value, min, max) => Math.min(max, Math.max(min, value))

export const el = {
  ...baseEl,
  smoothLoopToggle: byId("smoothLoopToggle"),
  smoothLoopToggleCard: byId("smoothLoopToggleCard"),
  smoothLoopFramesCard: byId("smoothLoopFramesCard"),
  smoothLoopFramesSlider: byId("smoothLoopFramesSlider"),
  smoothLoopFramesValue: byId("smoothLoopFramesValue"),
  smoothLoopHelper: byId("smoothLoopHelper"),
  motionBlurSlider: byId("motionBlurSlider"),
  motionBlurValue: byId("motionBlurValue"),
  motionBlurHelper: byId("motionBlurHelper"),
  loopDelaySlider: byId("loopDelaySlider"),
  loopDelayValue: byId("loopDelayValue"),
  statActualSize: byId("statActualSize"),
}

export { state }

export function getSettings() {
  const base = getBaseSettings()
  const requestedSmoothFrames = clamp(Number(el.smoothLoopFramesSlider?.value) || 8, 1, 60)
  const motionBlur = clamp(Number(el.motionBlurSlider?.value) || 0, 0, 100)
  return {
    ...base,
    smoothLoopRequested: Boolean(el.smoothLoopToggle?.checked),
    smoothLoopEnabled: Boolean(el.smoothLoopToggle?.checked && state.direction !== "rebound"),
    smoothLoopFrames: requestedSmoothFrames,
    motionBlur,
    motionBlurAmount: motionBlur / 100,
    loopDelayMs: loopDelayRawToMs(el.loopDelaySlider?.value || 0),
  }
}

export function getOutputDimensions(settings = getSettings()) {
  if (!state.sourceWidth || !state.sourceHeight) return { width: 0, height: 0 }
  const crop = state.crop || { x: 0, y: 0, width: 1, height: 1 }
  const cropWidth = Math.max(1, Math.round(state.sourceWidth * clamp(Number(crop.width) || 1, 0.05, 1)))
  const cropHeight = Math.max(1, Math.round(state.sourceHeight * clamp(Number(crop.height) || 1, 0.05, 1)))
  const sourceMax = Math.max(cropWidth, cropHeight)
  const outputMax = Math.max(1, Math.min(sourceMax, sourceMax * settings.scale / 100, settings.resolution))
  const ratio = outputMax / sourceMax
  return {
    width: Math.max(1, Math.round(cropWidth * ratio)),
    height: Math.max(1, Math.round(cropHeight * ratio)),
  }
}

export function clearActualSize() {
  if (el.statActualSize) el.statActualSize.textContent = "—"
}

export function revokeResult(showLive = true) {
  baseRevokeResult(showLive)
  clearActualSize()
}

export function disposeMedia() {
  baseDisposeMedia()
  clearActualSize()
}
